import {jsonMember, jsonObject} from "typedjson";
import {PitActivity} from "./pit-activity";

/** Мероприятие «донор» */

@jsonObject
export class PitActivityDonor {

  /** Уникальный идентификатор мероприятия */
  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  /** Куратор */
  @jsonMember({name: "curatorId", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _curatorId: number;

  /** Код мероприятия */
  @jsonMember({name: "code", constructor: String, emitDefaultValue: false, isRequired: false })
  private _code: string;

  /** Наименование мероприятия */
  @jsonMember({name: "name", constructor: String, emitDefaultValue: false, isRequired: false })
  private _name: string;

  /** Краткое наименование мероприятия */
  @jsonMember({name: "shortName", constructor: String, emitDefaultValue: false, isRequired: false })
  private _shortName: string;


  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get code(): string {
    return this._code;
  }

  set code(value: string) {
    this._code = value;
  }

  get name(): string {
    return this._name;
  }

  set name(value: string) {
    this._name = value;
  }

  get shortName(): string {
    return this._shortName;
  }

  set shortName(value: string) {
    this._shortName = value;
  }

  get curatorId(): number {
    return this._curatorId;
  }

  set curatorId(value: number) {
    this._curatorId = value;
  }

  static from(activity: PitActivity): PitActivityDonor {
    let result = new PitActivityDonor();
    result.id = activity.id;
    result.code = activity.code;
    //result.curatorId = ??
    result.name = activity.name;
    result.shortName = activity.shortName;
    return result;
  }
}
